module.exports = "/* MAIN COLOR PALETTE */\n.title {\n  font-family: 'Roboto-Medium';\n  font-size: 17px;\n  color: #B71C1C;\n  letter-spacing: 0;\n  margin: 13px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/ministers/minister-postulation/minister-postulation.component.scss
// module id = ./src/app/admin/pages/ministers/minister-postulation/minister-postulation.component.scss
// module chunks = main